import icon from '../../../assets/images/svg/cancel.svg';

const NotFound = () => {
   return (
      <div className="cart-container">
         <div className="content-error">
            <img src={icon} />
            <h4>Đơn hàng không tồn tại</h4>
            <p>Đơn hàng không còn tồn tại do cửa hàng đã thay đổi thông tin tài khoản hoặc đơn hàng đã bị xoá. </p>
         </div>
      </div>
   );
}

export default NotFound;